export const actionTypes = {
  SET_DOC_LIST: "SET_DOC_LIST",
  SET_DOC_TYPE_LIST: "SET_DOC_TYPE_LIST",
  SET_DOC_CENTER_TREE: "SET_DOC_CENTER_TREE",
  SET_DOC_CENTER_LIST: "SET_DOC_CENTER_LIST",
};